import { render, staticRenderFns } from "./ItemsSearch.vue?vue&type=template&id=4483acec&lang=html&"
import script from "./ItemsSearch.vue?vue&type=script&lang=js&"
export * from "./ItemsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports